<template></template>

<script>
    export default {
        name: 'GetToken',
        data() {
            return {
                auth: false,
            };
        },
        methods: {
            getToken() {
                const hash = this.$route.query.hash;
                const cn = this.$route.query.cn;
                this.$store.dispatch('getToken', { hash, cn });
            },
        },
        created() {
            this.getToken();
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Auth/GetToken.vue